import React from 'react'
import ReactModal from 'react-modal'
import http from 'src/helper/http'
import { isRtl } from 'src/helper/tool'

import './index.less'
import lang from '../lang'

export default class extends React.Component {
  // eslint-disable-next-line no-useless-constructor
  constructor(porps) {
    super(porps)
  }

  state = {
    visible: true,
    rewardlist: {}, // 所有列表
    activeList: [], // 当前列表
    activeAnchor: 'TOP1Country'
  }

  // 活动奖励列表
  async getRewardlist(type) {
    if (this.state.rewardlist[type]) {
      this.setState({
        activeList: this.state.rewardlist[type]
      })
      return
    }

    const copyRewardlist = JSON.parse(JSON.stringify(this.state.rewardlist))
    const data = await http.post('/web/activity/rewardlist', {
      activityKey: 'nationalStar',
      rewardType: type
    })

    const { code, res } = data
    if (code === 0 && res) {
      copyRewardlist[type] = res
      this.setState({
        rewardlist: copyRewardlist,
        activeList: copyRewardlist[type]
      })
    }
  }

  onToggleModal = async () => {
    this.props.onToggleModal(this.props.activeTab)
  }

  componentDidMount() {
    if (this.props.activeTab === 'rewards') {
      this.getRewardlist('TOP1Country')
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.activeTab !== prevProps.activeTab && this.props.activeTab === 'rewards') {
      this.getRewardlist('TOP1Country')
    }
  }

  getTitle = (index) => {
    const { lang } = this.props
    let title = ''
    switch (index) {
      case 0:
        title = lang.top1_user
        break
      case 1:
        title = lang.top2_user
        break
      default:
        title = lang.top3_user
        break
    }
    return title
  }

  getDays = (days) => {
    const { lang } = this.props
    let text = lang.days.replace(/\{0\}/g, days)
    return text
  }

  // 获取多语言name
  getLangName = (item) => {
    const { language } = this.props
    const txt = item[`name_${language}`] || item.name
    return txt
  }

  onToggleAnchor = (activeAnchor) => {
    this.setState({
      activeAnchor
    })
    this.getRewardlist(activeAnchor)
  }

  // 播放媒体
  onPlayMedia = (e, reward) => {
    e.stopPropagation()
    if (reward.show_url) {
      this.props.onSetActiveMedia(reward)
    }
  }

  render() {
    const { visible, activeTab, lang, language } = this.props
    const { activeList } = this.state

    return (
      <div className="modal-wrap">
        <div onClick={this.onToggleModal}>
          <ReactModal
            style={{
              overlay: {
                backgroundColor: 'rgba(0, 0, 0, 0.75)',
                zIndex: 1000
              }
            }}
            className={`rules-rewards--modal`}
            isOpen={visible}
            ariaHideApp={false}
          >
            <div
              className="rules-rewards-wrap"
              onClick={e => e.stopPropagation()}
            >
              <div className='hd'>
                <div className="hd-bg">
                  <div className="close-left" onClick={this.onToggleModal}></div>
                  <div className="close-right" onClick={this.onToggleModal}></div>
                  <h2>{lang.rules_ewards}</h2>
                </div>
                <div className={`hd-tab ${isRtl(language) ? 'arlang' : ''}`}>
                  <div
                    className={`tab-item ${activeTab === 'rules' ? 'active' : ''}`}
                    onClick={() => this.props.setTab('rules')}
                  >
                    {lang.rules}
                  </div>
                  <div
                    className={`tab-item ${activeTab === 'rewards' ? 'active' : ''}`}
                    onClick={() => this.props.setTab('rewards')}
                  >{lang.rewards}</div>
                </div>
              </div>
              {/* 背景图层 */}
              <div className="bd">
                <div className="bd-bg">
                  {
                    activeTab === 'rules' && (
                      <div className={`tab-rules-cont ${isRtl(language) ? 'arlang' : ''}`}>
                        <article>
                          <h2>{lang.global_star_ranking}</h2>
                          <p>{lang.global_star_ranking_description1}</p>
                          <p>{lang.global_star_ranking_description2}</p>
                        </article>
                        <article>
                          <h2>{lang.global_star_rewards}</h2>
                          <p>{lang.global_star_rewards_description1}</p>
                          <p>{lang.global_star_rewards_description2}</p>
                        </article>
                        <article>
                          <h2>{lang.national_star_ranking}</h2>
                          <p>{lang.national_star_ranking_description1}</p>
                        </article>
                        <article>
                          <h2>{lang.Other}</h2>
                          <p>{lang.Other_description1}</p>
                          <p>{lang.Other_description2}</p>
                        </article>
                      </div>
                    )
                  }
                  {
                    activeTab === 'rewards' && (
                      <div className="tab-rewards-cont">
                        <div className={`anchor-wrap ${isRtl(language) ? 'arlang' : ''}`}>
                          <div
                            className={`anchor-item ${this.state.activeAnchor === 'TOP1Country' ? 'active' : ''}`}
                            onClick={() => this.onToggleAnchor('TOP1Country')}
                          >
                            <span>{lang.top1_country}</span>
                          </div>
                          <div
                            className={`anchor-item ${this.state.activeAnchor === 'TOP2Country' ? 'active' : ''}`}
                            onClick={() => this.onToggleAnchor('TOP2Country')}
                          >
                            <span>{lang.top2_country}</span>
                          </div>
                          <div
                            className={`anchor-item ${this.state.activeAnchor === 'TOP3Country' ? 'active' : ''}`}
                            onClick={() => this.onToggleAnchor('TOP3Country')}
                          >
                            <span>{lang.top3_country}</span>
                          </div>
                        </div>
                        <div className="scroll-wrap">
                          <div className="stage-wrap">
                            {
                              activeList.length &&
                              activeList.map((item, index) => {
                                return (
                                  <div className="stage-gift" key={`${this.state.activeAnchor}_${index}`}>
                                    <span className="title">
                                      {this.getTitle(index)}
                                    </span>
                                    <div className="gift-list">
                                      {
                                        item.filter((filterChild) => filterChild.image_url).map((child) => {
                                          return (
                                            <div className="gift-item" key={`${this.state.activeAnchor}_${child.image_url}`}>
                                              <div
                                                className={`img-wrap ${child.show_url ? 'video' : ''} ${child.days === 0 ? 'no-days' : ''}`}
                                                onClick={(e) => this.onPlayMedia(e, child)}
                                              >
                                                {
                                                  child.show_url && (<div className="icon-video"></div>)
                                                }
                                                <img src={child.image_url} alt="" />
                                                {
                                                  child.days > 0 && (
                                                    <div className="tag">
                                                      x {this.getDays(child.days)}
                                                    </div>
                                                  )
                                                }
                                              </div>
                                              <p className="name">{this.getLangName(child)}</p>
                                            </div>
                                          )
                                        })
                                      }
                                    </div>
                                  </div>
                                )
                              })
                            }
                          </div>
                        </div>
                      </div>
                    )
                  }
                </div>
              </div>
              {/* 背景图层 */}
            </div>
          </ReactModal>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// src/pages/activity/national-star/rules-rewards/index.js